import { Box, Button,
  Grid, 
  Typography } from "@mui/material";
import CodeOffIcon from '@mui/icons-material/CodeOff';
import ReactTyped from "react-typed";
import DownloadIcon from '@mui/icons-material/Download';

const Header = () => {
  const handleOnDownload = () => {
    const link = document.createElement("a");
    link.download = `CV DEDDY GUNAWAN.pdf`;
    link.href = "./cv.pdf";
    link.click();
    console.log('tes');
  };

  return(
    <>
      <Box sx={{ minHeight: '700px', justifyContent: "center", alignItems: "center" }} style={{align: 'center', backgroundColor: '#e9d5a1', paddingTop: 180}}>
          <Typography component="h1" variant="h2" align="center" color="textPrimary" gutterBottom>
            <CodeOffIcon sx={{ fontSize: 120 }} />
          </Typography>
          <Typography sx={{ fontWeight: 'bold' }} component="h1" variant="h4" align="center" color="textPrimary" gutterBottom>
            Deddy Gunawan
          </Typography>

          <Grid container spacing={2} justifyContent="center" alignContent="center">
          <Grid item lg={6} md={6} sm={10} xs={10}>
          <Typography sx={{ textTransform: 'uppercase' }} variant="h6" align="center" color="textSecondary" paragraph>
            <ReactTyped 
              strings={['back end developer']}
              typeSpeed={40}
              backSpeed={50}
              loop
            />
          </Typography>
          </Grid>
          </Grid>

          <Grid container spacing={2} justifyContent="center" alignContent="center" paddingTop={8}>
            <Grid item>
              <Button onClick={handleOnDownload} variant="contained" startIcon={<DownloadIcon />}>
                download CV
              </Button>
            </Grid>
          </Grid>

      </Box>

    </>
  )
}

export default Header;
